import { render, staticRenderFns } from "./CashbackPartialPaymentBannerForProductCard.vue?vue&type=template&id=2f568cee&lang=pug&"
import script from "./CashbackPartialPaymentBannerForProductCard.vue?vue&type=script&lang=ts&"
export * from "./CashbackPartialPaymentBannerForProductCard.vue?vue&type=script&lang=ts&"
import style0 from "./CashbackPartialPaymentBannerForProductCard.vue?vue&type=style&index=0&id=2f568cee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports